import styled from 'styled-components';
import { Drawer, Button } from 'antd';

import * as Colors from '../../attrs/colors';

import MQ from '../../attrs/mq';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    box-shadow: none !important;
  }

  .ant-drawer-wrapper-body {
    overflow: hidden !important;
    background: ${Colors.GREY_20};
  }

  .ant-drawer-body {
    padding: 0;
    height: 100vh;
    display: flex;
  }

  .ant-drawer-close {
    color: ${Colors.WHITE};
    top: 12px;
    right: 10px;

    ${MQ.lg`
      right: 20px;
    `}
  }
`;

export const NavButton = styled(Button)`
  border-color: transparent;
  box-shadow: none;
  margin-left: 0;

  :hover {
    border-color: transparent;
  }

  ${MQ.xs`
    margin-left: 10px;
  `}
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  padding 0 1rem;

  ${MQ.lg`
    padding: 0 2rem;
  `}
`;
